import axios from 'axios';

axios.interceptors.request.use(req => req, error => Promise.reject(error));

axios.interceptors.response.use(res => res, async (error) => {
    const latestRequest = error.config;

    // Check if this is an authenticated request (has authorization header with token)
    const hasToken = latestRequest.headers?.authorization &&
        !latestRequest.headers.authorization.endsWith(' ') &&
        !latestRequest.headers.authorization.endsWith('null');

    const is401 = error.response?.status === 401;

    // Only redirect for 401 on authenticated requests (token expired/invalid)
    if (hasToken && is401) {
        console.log('Token expired - Clearing session');
        localStorage.clear();
        window.location.replace('/');
        return;
    }

    // For login failures or other errors, reject so the error can be handled
    return Promise.reject(error);
})

const json = `application/json; charset=utf-8`;
const multPart = `multipart/form-data; charset=utf-8`;

const request = async (contentType, method, url, data, options = {}) => {
    const token = JSON.parse(localStorage.getItem('token'));
    const orgId = JSON.parse(localStorage.getItem('orgId'));
    return await axios({
        url,
        headers: {
            'Content-Type': contentType,
            'authorization': token ? `Bearer ${token}` : '',
            'orgid': orgId ? `${orgId}` : ''
        },
        method: method,
        data,
        ...options
    });
};

const unAuthRequest = async (method, url, data) => {
	return await axios({
		url,
		headers: {
			'Content-Type': 'application/json; charset=utf-8',
		},
		method: method,
		data,
	});
};

// application/json
export const getRequest = (url) => request(json, 'GET', url);
export const postRequest = (url, data) => request(json, 'POST', url, data);
export const putRequest = (url, data) => request(json, 'PUT', url, data);
export const deleteRequest = (url, data) => request(json, 'DELETE', url, data);

// multipart/formData
export const putRequestFormData = (url, data, options = {}) => request(multPart, 'PUT', url, data, options);
export const postRequestFormData = (url, data, options = {}) => request(multPart, 'POST', url, data, options);

//unAuth
export const postUnauthRequest = (url, data) => unAuthRequest('POST', url, data);
export const getUnauthRequest = (url, data) => unAuthRequest('GET', url, data);
